import { useRef } from 'react';
import { useLocation } from 'wouter';

import { slugFromPath } from '../store-events/store-events';

function storedSlug(): string {
  try {
    const stored = sessionStorage.getItem('store-slug');
    return stored && stored !== 'undefined' ? stored : '';
  } catch {
    return '';
  }
}

/**
 * Loja atual para o Pixel/GTM (PRAT-19).
 *
 * O AnalyticsProvider fica fora do <Router>: o `useParams` dele vem vazio e o
 * `useStoreSlug` guarda (em useMemo) o que havia no sessionStorage na primeira
 * renderização. Na primeira visita isso era vazio, e o Pixel e o GTM não
 * ligavam; no carrinho, no checkout e no login a loja se perdia e o analytics
 * desligava no meio da compra. Aqui a loja sai da URL e, nas telas que não são
 * de loja (/cart, /auth, /orders), fica a última loja aberta.
 */
export function useAnalyticsStoreSlug(): string {
  const [location] = useLocation();
  const last = useRef('');

  const fromPath = slugFromPath(location);
  if (fromPath) {
    last.current = fromPath;
  } else if (!last.current) {
    last.current = storedSlug();
  }

  return last.current;
}
